import React from "react";
import { connect } from "react-redux";
import { SubNav } from "app/components/sub-navigation-bar/SubNav";
import type { ISegmentsData } from "app/services/conversion/ConversionSegmentsService";
import { ConversionResponsiveFilters } from "./ConversionResponsiveFilters";
import { withUIRouter } from "app/components/React/HOCs/withUIRouter";
import type { UIRouterReact } from "@uirouter/react/lib/core";
import { proNavigator } from "single-spa/react-app/ProNavigator";

interface IConversionSubNavProps {
    router: UIRouterReact;
    segments: ISegmentsData;
}

class ConversionSubNav extends React.PureComponent<IConversionSubNavProps, any> {
    private swNavigator;
    private LeftComponent;

    public constructor(props) {
        super(props);
        this.swNavigator = proNavigator;
        const params = this.swNavigator.getParams();
        const currentPage = this.swNavigator.current().name;
        this.state = {
            loadingMeta: true,
            params,
            currentPage,
        };
    }

    public async componentDidMount() {
        const router = this.props.router;
        router.transitionService.onSuccess({}, (transition) =>
            this.setState({
                ...this.state,
                currentPage: transition.to().name,
                params: transition.params(),
            }),
        );
        const params = this.swNavigator.getParams();
        const currentPage = this.swNavigator.current().name;
        this.setState({
            loadingMeta: false,
            params,
            currentPage,
        });
    }

    public render() {
        this.LeftComponent = this.swNavigator.current().leftSubNav;

        if (!this.props.segments) {
            return null;
        }

        return (
            <SubNav
                bottomLeftComponent={<this.LeftComponent />}
                bottomRightComponent={
                    <ConversionResponsiveFilters
                        currentPage={this.state.currentPage}
                        params={this.state.params}
                        segmentsData={this.props.segments}
                    />
                }
            />
        );
    }
}

function mapStateToProps({ conversionModule: { segments } }) {
    return {
        segments,
    };
}
export default connect(mapStateToProps, null)(withUIRouter(ConversionSubNav));
